import React, { useState } from "react";
import {
  LayersControl,
  MapContainer,
  TileLayer,
  useMap,
  WMSTileLayer
} from "react-leaflet";
import "./style.scss";
import FormSearch from "./formSearch/index";
import { API_GEOSERVER_URI, API_GEOSERVER_URI_QUERY } from "../../api2";
import { Constant } from "../../constants/constant";

export default function BanDo() {
  const [center, setCenter] = useState(Constant?.PositionInit);
  const [zoom, setZoom] = useState(10);

  function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
    return null;
  }

  // const FlyToLocation = ({ valuePositionFly }) => {
  //     const map = useMap();
  //     useEffect(() => {
  //         if (valuePositionFly) {
  //             map.flyTo(valuePositionFly, 13, {
  //                 animate: true,
  //                 duration: 2 // Thời gian bay tới (tính bằng giây)
  //             });
  //         }

  //     }, [valuePositionFly, map]);
  // };

  return (
    <div style={{ height: "calc(100vh - 82px)" }}>
      <MapContainer
        scrollWheelZoom={true}
        zoomControl={true}
        maxZoom={18}
        minZoom={6}
        attributionControl={true}
        center={center}
        zoom={zoom}
        style={{ width: "100%", height: "100%", cursor: "default" }}
      >
        <ChangeView center={center} zoom={zoom} />
        <LayersControl position="topright">
          <LayersControl.Overlay checked name="Openstreetmap (tham khảo)">
            <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            type={"satellite"}
          />
          </LayersControl.Overlay>
          <WMSTileLayer
            maxZoom={30}
            layers={"nenbiendong"}
            params={{
              transparent: true,
              format: "image/png",
              tiled: true,
              SRS: "EPSG:9009113"
            }}
            url={API_GEOSERVER_URI}
          ></WMSTileLayer>
          <LayersControl.Overlay name="Bình độ 100">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:binhdo100"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Buffer">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:buffer"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Cầu bê tông">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:vgcaubetong"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Chỉ dẫn địa lý">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:vgcddl"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Giao thông">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:vggiaothong"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Ranh giới huyện">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:vgrghuyen"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Ranh giới xã">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:vgrgxa"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Buffer biển">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:bufferbien"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Tên huyện">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:tenhuyen"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Tên xã">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:tenxa"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Vùng nuôi">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:vgcachinh"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
          <LayersControl.Overlay checked name="Vùng sản xuất">
            <WMSTileLayer
              maxZoom={30}
              layers={"CaChinhBong:VungSanXuat"}
              params={{
                transparent: true,
                format: "image/png",
                tiled: true,
                SRS: "EPSG:9009113"
              }}
              url={API_GEOSERVER_URI}
            ></WMSTileLayer>
          </LayersControl.Overlay>
        </LayersControl>
        <FormSearch setCenter={setCenter} setZoom={setZoom} />
      </MapContainer>
    </div>
  );
}
